import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AppService } from '../../app.service';
import { AuthService } from '../../core/auth/auth.service';
import { Credentials } from '../../core/auth/interfaces/credentials.interface';

const env = environment;
@Component({
  selector: 'appAuth-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  private credentials: Credentials = {
    email: null,
    password: null,
    uid: null
  };

  private credNotFound = false;
  public hidePW = true;
  public loggedIn = false;
  public ssoClientUrl = '';

  public emailFormControl = new FormControl(this.credentials.email, [
    Validators.required,
    Validators.email,
    (c: AbstractControl) => {
      if (!this.credNotFound) {
        return null;
      } else {
        return {
          cred_found: {
            valid: false
          }
        };
      }
    }
  ]);

  public passwordFormControl = new FormControl(this.credentials.password, [
    Validators.required,
    (c: AbstractControl) => {
      if (!this.credNotFound) {
        return null;
      } else {
        return {
          cred_found: {
            valid: false
          }
        };
      }
    }
  ]);

  constructor(private appAuth: AuthService, private route: ActivatedRoute, private app: AppService) {
    if(environment && environment.ssoClient && environment.ssoClient.url) {
      this.ssoClientUrl = environment.ssoClient.url;
    }
  }

  ngOnInit(): void {
  }

  public onSubmit(): void {
    this.credentials.email = this.emailFormControl.value;
    this.emailFormControl.updateValueAndValidity();
    this.credentials.password = this.passwordFormControl.value;
    this.passwordFormControl.updateValueAndValidity();
    if (!this.passwordFormControl.errors && !this.emailFormControl.errors && this.validateEmail()) {
      this.auth();
    }
  }

  protected validateEmail() {
    let access;
    if(environment.production) {
      access = /@staatsanzeiger.de\s*$/.test(this.credentials.email)
    } else {
      access = /@staatsanzeiger.de\s*$/.test(this.credentials.email) || /@localhost\s*$/.test(this.credentials.email)
    }

    if (access) {
      return true;
    } else {
      this.app.toast.open('Zugang nur für Mitarbeiter des SBW verfügbar.', null, {
        panelClass: 'warn'
      });
      return false;
    }
  }

  protected auth() {
    this.appAuth.auth(this.credentials).then((auth: boolean) => {
      this.loggedIn = true;
      console.log(auth);
      this.appAuth.router.navigateByUrl('admin');
    }).catch((e: HttpErrorResponse) => {
      this.app.toast.open('Unbekannter Fehler', null, {
        panelClass: 'warn'
      });

    });
  }

}
